import * as Constants from './constants'

export const nhaCungCapListRequest = function nhaCungCapListRequest(formData) {
  return {
    type: Constants.NHACUNGCAP_LIST_REQUESTING,
    payload: formData
  }
}

export const nhaCungCapListSuccess = function nhaCungCapListSuccess(data) {
  return {
    type: Constants.NHACUNGCAP_LIST_SUCCESS,
    data
  }
}

export const nhaCungCapListError = function nhaCungCapListError(error) {
  return {
    type: Constants.NHACUNGCAP_LIST_ERROR,
    error
  }
}

export const nhaCungCapDetailRequest = function nhaCungCapDetailRequest(formData) {
  return {
    type: Constants.NHACUNGCAP_DETAIL_REQUESTING,
    payload: formData
  }
}

export const nhaCungCapDetailSuccess = function nhaCungCapDetailSuccess(data) {
  return {
    type: Constants.NHACUNGCAP_DETAIL_SUCCESS,
    data
  }
}

export const nhaCungCapDetailError = function nhaCungCapDetailError(error) {
  return {
    type: Constants.NHACUNGCAP_DETAIL_ERROR,
    error
  }
}

export const nhaCungCapUpdateRequest = (formData, callback) => {
  return {
    type: Constants.NHACUNGCAP_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nhaCungCapUpdateSuccess = function nhaCungCapUpdateSuccess(response) {
  return {
    type: Constants.NHACUNGCAP_UPDATE_SUCCESS,
    payload: response
  }
}

export const nhaCungCapUpdateError = function nhaCungCapUpdateError(error) {
  return {
    type: Constants.NHACUNGCAP_UPDATE_ERROR,
    error
  }
}

export const nhaCungCapRemoveRequest = (formData, callback) => {
  return {
    type: Constants.NHACUNGCAP_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nhaCungCapRemoveSuccess = (response) => {
  return {
    type: Constants.NHACUNGCAP_REMOVE_SUCCESS,
    payload: response
  }
}

export const nhaCungCapRemoveError = (error) => {
  return {
    type: Constants.NHACUNGCAP_REMOVE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/NhaCC/actions.js